export class Merchant {
    id: number;
    externalRef: string;
    name: string;
    merchantStatus: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    createdBy: string;
    createdDate: string;
    deletedBy: string;
    acceptFraudLiability: boolean;
    paymentMeans: Array<string>;
    deleted: string;
    logicalDeletionDate: string;
    address: {
        address_line1: string;
        address_line2: string;
        address_line3: string;
        city: string;
        country: string;
        zip_code: string;
    };
    contact: {
        email: string;
        firstName: string;
        lastName: string;
        tel: string;
    };
    callbacks: {
      callbackTransactionDataUrl: string;
      callbackTransactionStateUrl: string;
      callbackTransactionDataEnabled: boolean;
      callbackTransactionStateEnabled: boolean;
      callbackSecretKey: string;
    }
}
